<template>
  <div>
    <div class="space-y-4">
      <div class="flex justify-between">
        <h2 class="font-semibold uppercase text-gray-600">Logs</h2>
        <select class="form-select" v-model="level" @change="getLogs">
            <option :selected="level === 'all'" value="all">
              All
            </option>
            <option :selected="level === 'info'" value="info">
              Info
            </option>
            <option :selected="level === 'error'" value="error">
              Error
            </option>
        </select>
      </div>
    </div>
    <div class="inline-block min-w-full shadow rounded-lg mt-4">
      <table class="min-w-full leading-normal">
        <thead>
          <tr>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >time</th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >message</th>
          </tr>
        </thead>
        <tbody class="relative" v-if="logs.data && logs.data.length">
          <tr v-for="(log, index) in logs.data" :key="index">
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">{{ log.timestamp }}</td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">{{ log.message }}</td>
          </tr>
          <div
            v-if="loading"
            class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
          >
            <i class="material-icons text-6xl spin">sync</i>
            <span class="block invisible">Loading...</span>
          </div>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="bg-white py-4 text-center text-gray-600 font-semibold">
              <div v-if="loading" class="inline-block">
                <i class="material-icons text-6xl spin">sync</i>
                <span class="block invisible">Loading...</span>
              </div>
              <div v-else class="inline-block">
                <i class="material-icons text-6xl">warning</i>
                <span class="block">No logs found!</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex justify-between items-end">
      <p class="text-gray-600"></p>
      <div class="flex items-center space-x-4">
        <div class="space-x-2 flex">
          <button
            @click="goToPrev"
            type="button"
            class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <!-- <button
            v-for="page in total"
            :key="`pageLink-${page}`"
            type="button"
            class="p-2"
            :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page,
              }"
            :disabled="currentPage === page"
            @click="goToPage(page)"
          >{{ page }}</button> -->
          <button
            @click="goToNext"
            type="button"
            class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
          >
            <i class="material-icons">chevron_right</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from "lodash";
import Pagination from "@/mixins/Pagination";
export default {
  mixins: [Pagination],
  data() {
    return {
      logs: [],
      loading: true,
      perPage: 30,
      level: "all",
      searchKey: ""
    };
  },
  created() {
    this.getLogs();
  },
  watch: {
    currentPage() {
      this.getLogs();
    }
  },
  methods: {
    getLogs() {
      this.loading = true;
      var path =
        'logs?limit=' + this.perPage + "&page=" + this.currentPage;

      if (this.searchKey) {
        path += "&q=" + this.searchKey;
      }

      if (this.level && this.level != "all") {
        path += "&level=" + this.level;
      }
      this.$http
        .get(path)
        .then(response => {
          this.logs = response.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    }
  }
};
</script>